export class FileExtension {
    public static isImage (file: File) {
        // return file && /^image\/\w+/.test(file.type);
        return true;
    }
}